import type { CollabAnnotation } from '@/services/collab-session-service';

export type AnnotationType = 'highlight' | 'comment' | 'drawing' | 'bookmark' | 'tag';

export interface CollabAnnotationPosition {
  start?: number;
  end?: number;
  selectedText?: string;
  tabId?: string;
  tabTitle?: string;
  tabUrl?: string;
  x?: number;
  y?: number;
}

export interface CollabTextSelection {
  selectedText: string;
  start: number;
  end: number;
}

export interface CollabSharedDocument {
  tabId: string;
  title: string;
  url: string;
  body: string;
  source: 'extract' | 'analysis' | 'summary';
}

export const ANNOTATION_COLORS: Record<AnnotationType, string> = {
  highlight: '#FBBF24',
  comment: '#3B82F6',
  drawing: '#8B5CF6',
  bookmark: '#10B981',
  tag: '#EC4899',
};

export function getAnnotationPosition(ann: CollabAnnotation): CollabAnnotationPosition {
  return (ann.position ?? {}) as CollabAnnotationPosition;
}

export function getSelectedQuote(ann: CollabAnnotation): string {
  const pos = getAnnotationPosition(ann);
  return pos.selectedText?.trim() || '';
}

export function getAnnotationNote(ann: CollabAnnotation): string {
  const quote = getSelectedQuote(ann);
  const note = ann.content?.trim() || '';
  if (!note) return '';
  if (quote && note === quote) return '';
  return note;
}
